module.exports = __webpack_public_path__ + "img/hayanshuf-header.7065ab26.svg";